import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';

export default ({loadingMessage}) => (
  <Spin
    tip={loadingMessage}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    indicator={
      <div style={{ marginRight: '8px', marginTop:'-18px' }}>
        <LoadingOutlined style={{ fontSize: '20px', color:'#ffffff' }} />
      </div>
    }
  />
);
